import { useEffect, useState } from "react";
import { inspectionApi } from "../inspection/api";
import { tierColor } from "../inspection/TierBadge";

export const RenderHubCard = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { inspectionApi.hubRecent().then((d) => setRows(d.rows || [])).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <div data-testid="cockpit-render-hub-card" style={{ width: "100%", background: "#0A1730", border: "1px solid #1E3354", borderRadius: 12, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 6 }}>
      <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "#5AC8D8", fontWeight: 800 }}>Render Hub · latest inspections</div>
      {rows.slice(0, 3).map((r) => (
        <a key={r.inspection_id} href={`/render-hub/${r.inspection_id}`} data-testid={`cockpit-hub-${r.inspection_id}`}
           style={{ display: "flex", justifyContent: "space-between", gap: 10, color: "#F5F5F7", textDecoration: "none", fontSize: 14, padding: "6px 0", borderTop: "1px dashed #1E3354" }}>
          <span style={{ minWidth: 0, overflowWrap: "anywhere" }}>{r.address}{r.unit_label ? ` · ${r.unit_label}` : ""}</span>
          <b style={{ color: tierColor(r.classification?.tier), whiteSpace: "nowrap" }}>{r.classification?.label} →</b>
        </a>
      ))}
    </div>
  );
};
